module.exports = __webpack_public_path__ + "img/headphones.a14b95a8.jpg";